import api from '../utils/api';
import config from '../config';

const settingService = {
  /**
   * Get all settings grouped by category
   * @returns {Promise} Settings data
   */
  getSettings: async () => {
    return api.get(config.endpoints.settings.list);
  },

  /**
   * Update settings
   * @param {Object} settingsData - Settings data to update
   * @returns {Promise} Response data
   */
  updateSettings: async ({ password, settings }) => {
    return api.put(config.endpoints.settings.update, {
      password,
      settings,
    });
  },
};

export default settingService;
